module.exports = __webpack_public_path__ + "img/navTwo-img.d35517d2.png";